import React, { useState, useContext } from 'react';
import { Row, Col } from 'react-bootstrap';
import AnimationContainer from '../../components/animation-container';
import BaffleText from '../../components/baffle-text';
import ThemeContext from '../../context';

const ContactForm = ({ id }) => {
  const { height } = useContext(ThemeContext);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [error, setError] = useState(false);
  const [show, setShow] = useState(false);
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState(null); // for success/error messages

  const showForm = () => setShow(true);

  const check = (val) => {
    if (error && val === '') {
      return false;
    }
    return true;
  };

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const submit = async () => {
    if (
      formData.name === '' ||
      formData.email === '' ||
      formData.message === ''
    ) {
      setError(true);
      setStatus({ type: 'error', text: 'Please fill in all required fields.' });
      return;
    }

    setError(false);
    setSending(true);
    setStatus(null);

    try {
      const response = await fetch('/server/send-email.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData).toString(),
      });

      const data = await response.json();

      if (response.ok) {
        setStatus({ type: 'success', text: data.success });
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        setStatus({ type: 'error', text: data.error });
      }
    } catch (err) {
      setStatus({
        type: 'error',
        text: 'An error occurred. Please try again later.',
      });
    } finally {
      setSending(false);
    }
  };

  const form = () => {
    if (show || height === 'auto') {
      return (
        <AnimationContainer delay={0} animation='fadeInUp fast'>
          <div className='form-container'>
            <div className='line-text'>
              <h4>Get In Touch</h4>

              <AnimationContainer delay={50} animation='fadeInUp fast'>
                <div className='form-group'>
                  <input
                    type='text'
                    className={`name ${check(formData.name) ? '' : 'error'}`}
                    placeholder='Name *'
                    onChange={handleChange('name')}
                    value={formData.name}
                  />
                </div>
              </AnimationContainer>

              <AnimationContainer delay={100} animation='fadeInUp fast'>
                <div className='form-group'>
                  <input
                    type='email'
                    className={`email ${check(formData.email) ? '' : 'error'}`}
                    placeholder='Email *'
                    onChange={handleChange('email')}
                    value={formData.email}
                  />
                </div>
              </AnimationContainer>

              <AnimationContainer delay={150} animation='fadeInUp fast'>
                <div className='form-group'>
                  <input
                    type='text'
                    className='phone'
                    placeholder='Phone'
                    onChange={handleChange('phone')}
                    value={formData.phone}
                  />
                </div>
              </AnimationContainer>

              <AnimationContainer delay={200} animation='fadeInUp fast'>
                <div className='form-group'>
                  <textarea
                    className={`message ${
                      check(formData.message) ? '' : 'error'
                    }`}
                    placeholder='Message *'
                    onChange={handleChange('message')}
                    value={formData.message}
                  ></textarea>
                </div>
              </AnimationContainer>

              <AnimationContainer delay={250} animation='fadeInUp fast'>
                <div className='submit'>
                  <button
                    className={`hover-button ${error ? 'error' : ''}`}
                    onClick={submit}
                    disabled={sending}
                  >
                    <span>{sending ? 'Sending...' : 'Send Message'}</span>
                  </button>
                </div>
              </AnimationContainer>

              {status && (
                <AnimationContainer delay={300} animation='fadeInUp fast'>
                  <p
                    className={`status-message ${
                      status.type === 'success' ? 'success' : 'error'
                    }`}
                  >
                    {status.text}
                  </p>
                </AnimationContainer>
              )}
            </div>
          </div>
        </AnimationContainer>
      );
    }
    return null;
  };

  return (
    <section id={id} className='contact' style={{ height }} tabIndex={0}>
      <Row>
        <Col md={2} className='side'>
          <h2>
            <BaffleText
              text='Contact'
              revealDuration={500}
              revealDelay={500}
              parentMethod={showForm}
              callMethodTime={1100}
            />
          </h2>
        </Col>

        <Col md={5} sm={12} className='form'>
          {form()}
        </Col>

        <Col md={5}>
          <AnimationContainer delay={400} animation='fadeIn slow'>
            <div className='design'></div>
          </AnimationContainer>
        </Col>
      </Row>
    </section>
  );
};

export default ContactForm;
